import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CloseIcon from '@mui/icons-material/Close';
import { translate } from '../../helper';

const BootstrapDialog = styled(Dialog)(({ theme, color, width, padding, weight, textAlign, marginTitleTop, marginTitleLeft }) => ({
    '& .MuiDialog-root': {
        'overflow': 'visible',
    },
    '& .MuiDialogTitle-root': {
        'fontWeight': weight || 'bold',
        'backgroundColor': color||'white',
        'color': 'black',
        'textAlign': textAlign || 'center',
        'minHeight': 'calc(var(--fs-xl)*2.5)',
         marginTop: marginTitleTop || '0px',
         marginLeft: marginTitleLeft || '0px',
         padding: marginTitleLeft && marginTitleTop ? '0px' : 'calc(var(--sp-md2)*1.6842105) calc(var(--sp-md2)*2.5263157)',
         display:'flex',
         alignItems:'center',
         'overflow': 'visible',
         'position': 'relative',
    },
    '& .MuiDialogContent-root':{
        'padding': padding || 'var(--sp-lg) calc(var(--sp-md2)*3.5)',
        'width': 'auto',
        'borderTop': '0',
        'backgroundColor': color||'white',
        'overflow': 'visible',
        'position': 'relative',
    },
    '& .MuiDialogActions-root': {
        'padding': 'var(--sp-md2) 0',
        'overflow': 'visible',
    },
    '& .MuiButtonBase-root': {
        'padding': 'var(--sp-md2) 0',
        'color': color?'white':"#000",
    },
    '& .MuiPaper-root': {
        'borderRadius': 'calc(var(--sp-xxs)*2)',
        'overflow': 'visible',
        'position': 'relative',
    }
}));

export const DraggablePaper = React.forwardRef(function DraggablePaper(props, ref) {
    const { style, className, children, ...rest } = props;
    const [pos, setPos] = React.useState({ x: null, y: null });
    const dragInfoRef = React.useRef(null);

    const onMouseMove = React.useCallback((e) => {
        const info = dragInfoRef.current;
        if (!info) return;
        const dx = e.clientX - info.startX;
        const dy = e.clientY - info.startY;
        setPos({ x: info.startPos.x + dx, y: info.startPos.y + dy });
    }, []);

    const onMouseUp = React.useCallback(() => {
        dragInfoRef.current = null;
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onMouseUp);
    }, [onMouseMove]);

    const onMouseDown = React.useCallback((e) => {
        const handle = e.target.closest('[data-draggable-handle="true"]');
        if (!handle) return;
        const startX = e.clientX;
        const startY = e.clientY;
        const host = e.currentTarget;
        const rect = host.getBoundingClientRect();
        const currentPos = { x: rect.left, y: rect.top };
        dragInfoRef.current = { startX, startY, startPos: currentPos };
        setPos(currentPos);
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        e.preventDefault();
    }, [onMouseMove, onMouseUp]);

    React.useEffect(() => {
        return () => {
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
        };
    }, [onMouseMove, onMouseUp]);

    const baseStyle = React.useMemo(() => {
        if (pos.x == null || pos.y == null) return undefined;
        return {
            position: 'fixed',
            top: pos.y,
            left: pos.x,
            margin: 0,
            transform: 'none',
        };
    }, [pos]);

    return (
        <div
            ref={ref}
            className={className}
            style={{ ...style, ...(baseStyle || {}) }}
            onMouseDown={onMouseDown}
            {...rest}
        >
            {children}
        </div>
    );
});

function Modal({ title, isOpen, onClose, children, style={}, fullScreen, showHeader=true, width, padding, draggable=false , weight, fontSize, textAlign , marginTitleTop, marginTitleLeft, isIcon=false, Icon=null, minWidth}) {

    const theme = useTheme();

    return (
        <div>
            <BootstrapDialog
                onClose={onClose}
                maxWidth={false}
                open={isOpen}
                color={style.backgroundColor}
                fullScreen={fullScreen}
                width={width}
                padding={padding}
                weight={weight}
                textAlign={textAlign}
                marginTitleTop={marginTitleTop}
                marginTitleLeft={marginTitleLeft}
                PaperProps={{
                    style: {
                        ...(width ? { width } : minWidth ? { minWidth } : { width: 'calc(var(--fs-hero)*15)' }),
                        maxWidth: 'unset',
                    },
                }}
                PaperComponent={draggable ? DraggablePaper : undefined}
            >
                {showHeader&&<>
                    <DialogTitle data-draggable-handle="true" sx={{ cursor: draggable ? 'move' : 'default', fontSize: fontSize || 'calc(var(--fs-xs)*1.9)' }}>
                        {isIcon && Icon && <>{Icon}</>}
                        {translate(title)}
                    </DialogTitle>
                    
                        <CloseIcon sx={{ fontSize: 'calc(var(--fs-sm)*2)',position: 'absolute',
                            right: marginTitleLeft || 'calc(var(--sp-xxs)*2)',
                            top: marginTitleTop || 'calc(var(--sp-xxs)*2)',
                            color: '#000', 
                            cursor: 'pointer'
                        }}
                            onClick={onClose}                   
                        />
                </>}
                <DialogContent dividers>
                    {children}
                </DialogContent>
            </BootstrapDialog>
        </div>
    );
}

export default Modal;